export default "__VITE_ASSET__fe814cf9__"